export default "__VITE_ASSET__CkmWQeNZ__"